import Layout from "./components/Layout/Layout";
import { CartProvider } from "./context/CartContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <CartProvider>
          <Layout />
        </CartProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
